module.exports = __webpack_public_path__ + "img/cover_brown_body.7ff151aa.png";